import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import * as React from 'react';
import { style as tss } from 'typestyle';
import { useSelector } from '@src/utils/hooks';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { Button } from 'antd';
import { LABELS } from '../dictionaries';
import { logoutFromAuthProvider } from '../app-auth';
import { getAuthUser } from '../modules/auth/auth-selectors';
import { defaultTheme } from '@src/styles';
import { Avatar, Tooltip } from '../../src/controls';
import {
  getMasterSiteNameOrEmpty,
  getSelectedSiteIdOrEmpty,
} from '@src/modules/sites/sites-selectors';

export const UserCard = () => {
  const ldClient = useLDClient();

  const siteId = useSelector(getSelectedSiteIdOrEmpty);

  // in context of the AB experiment, the app loads the experiment sites to the global context, making the master site data unavailable
  // thus the value might be empty here.
  // TODO: seems to be not used in LD, consider cleaning up alongside the getMasterSite* selectors
  const siteName = useSelector(getMasterSiteNameOrEmpty);
  const user = useSelector(getAuthUser);

  React.useEffect(() => {
    ldClient?.identify({
      key: user?.id,
      name: user?.name,
      email: user?.email,
      custom: { isSuperUser: !!user?.superUser, currentSiteId: siteId, currentSiteName: siteName },
    });
  }, [user, siteId, siteName]);

  return (
    <div className={classStyles.root}>
      <Avatar
        size="small"
        icon={<UserOutlined />}
        src={(user && user.picture) || ''}
        className={classStyles.avatar}
      />
      <span className={classStyles.userName}>
        {user ? user.name || user.email || LABELS.DEFAULT_NAME : LABELS.DEFAULT_NAME}
      </span>
      <Tooltip placement="top" title={LABELS.LOG_OUT_TOOLTIP}>
        <Button
          size="small"
          onClick={() => {
            logoutFromAuthProvider();
          }}
          className={classStyles.logout}
        >
          <LogoutOutlined />
        </Button>
      </Tooltip>
    </div>
  );
};

const classStyles = {
  root: tss({
    display: 'flex',
    alignItems: 'center',
    padding: '15px 20px',
    backgroundColor: defaultTheme.color.neutralDark,
    marginTop: 'auto',
    width: '100%',
  }),
  avatar: tss({
    backgroundColor: defaultTheme.color.primary,
    marginRight: '6px',
  }),
  logout: tss({
    marginLeft: 'auto',
    backgroundColor: defaultTheme.color.neutralDark,
  }),
  userName: tss({
    maxWidth: '90%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  }),
};
